import { ReactComponent as DashboardIcon } from '../../../../assets/vectors/dashboard.svg';
import { ReactComponent as GroupIcon } from '../../../../assets/vectors/group.svg';
// import { ReactComponent as HistoryIcon } from "../../../../assets/vectors/history.svg";
import { ReactComponent as ProspectionIcon } from '../../../../assets/vectors/support_agent.svg';
import { ReactComponent as ConsultationIcon } from '../../../../assets/vectors/receipt_long.svg';
import { ReactComponent as PaymentIcon } from '../../../../assets/vectors/payments.svg';
import { ReactComponent as ReceiptIcon } from '../../../../assets/vectors/receipt.svg';
import { ReactComponent as UserIcon } from '../../../../assets/vectors/user.svg';
import { ReactComponent as StatsIcon } from '../../../../assets/vectors/monitoring.svg';
import { ReactComponent as QueryStatsIcon } from '../../../../assets/vectors/query_stats.svg';
import { ReactComponent as StoreIcon } from '../../../../assets/vectors/store.svg';
import { ReactComponent as DateRangeIcon } from '../../../../assets/vectors/date_range.svg';
import { ReactComponent as EventIcon } from '../../../../assets/vectors/event_busy.svg';
import { ReactComponent as MembershipIcon } from '../../../../assets/vectors/card_membership.svg';
import { ReactComponent as MapIcon } from '../../../../assets/vectors/map.svg';
import { UserRoles } from '../../../../types/models/user/user.types';
import { DashboardPages } from '../DashboardLayout.types';
import { DashboardSidebarLinksList } from './DashboardSidebar.types';

const IS_ACTUAL_PUB_DASHBOARD_ENABLED = true;

export const dashboardSidebarLinks: DashboardSidebarLinksList = Object.freeze({
  [UserRoles.AcheteurPublic]: !IS_ACTUAL_PUB_DASHBOARD_ENABLED
    ? [
        {
          icon: UserIcon,
          label: 'Inscription confirmée',
          path: DashboardPages.Home,
        },
      ]
    : [
        {
          icon: DashboardIcon,
          label: 'Tableau de bord',
          path: DashboardPages.Home,
        },
        {
          icon: ConsultationIcon,
          label: 'Consultations',
          path: DashboardPages.Consultations,
        },
        {
          icon: MapIcon,
          label: 'Carte des Entreprises',
          path: DashboardPages.Map,
        },
        {
          icon: StoreIcon,
          label: 'Annuaire des Entreprises',
          path: DashboardPages.Companies,
        },
        {
          icon: ReceiptIcon,
          label: 'Mes Factures',
          path: DashboardPages.Receipts,
        },
        {
          icon: UserIcon,
          label: 'Mes Informations',
          path: DashboardPages.Profile,
        },
      ],
  [UserRoles.Entreprise]: [
    {
      icon: DashboardIcon,
      label: 'Tableau de bord',
      path: DashboardPages.Home,
    },
    // {
    //   icon: HistoryIcon,
    //   label: 'Historique',
    //   path: DashboardPages.Historique
    // },
    {
      icon: DateRangeIcon,
      label: 'Consultation en cours',
      path: DashboardPages.InProgressConsultations,
    },
    {
      icon: EventIcon,
      label: 'Consultation terminées',
      path: DashboardPages.ClosedConsultations,
    },
    {
      icon: ReceiptIcon,
      label: 'Mes Factures',
      path: DashboardPages.Receipts,
    },
    {
      icon: MembershipIcon,
      label: 'Mes Souscriptions',
      path: DashboardPages.Subscriptions,
    },
    {
      icon: UserIcon,
      label: 'Mes Informations',
      path: DashboardPages.Profile,
    },
  ],
  [UserRoles.DirecteurCommercial]: [
    {
      icon: DashboardIcon,
      label: 'Tableau de bord',
      path: DashboardPages.Home,
    },
    {
      icon: GroupIcon,
      label: 'Commerciaux',
      path: DashboardPages.Commerciaux,
    },
    {
      icon: ProspectionIcon,
      label: 'Prospects',
      path: DashboardPages.Prospect,
    },
    {
      icon: QueryStatsIcon,
      label: 'Résultats',
      path: DashboardPages.Results,
    },
    {
      icon: StatsIcon,
      label: 'Statistiques',
      path: DashboardPages.Stats,
    },
  ],
  [UserRoles.Commercial]: [
    {
      icon: DashboardIcon,
      label: 'Tableau de bord',
      path: DashboardPages.Home,
    },
    {
      icon: ProspectionIcon,
      label: 'Prospection',
      path: DashboardPages.Prospection,
    },
    // {
    //   icon: GroupIcon,
    //   label: 'Mes Prospects',
    //   path: DashboardPages.Prospect
    // },
    {
      icon: DateRangeIcon,
      label: 'Consultation en cours',
      path: DashboardPages.InProgressConsultations,
    },
    {
      icon: PaymentIcon,
      label: 'Facturation',
      path: DashboardPages.Facturation,
    },
    {
      icon: StatsIcon,
      label: 'Statistiques',
      path: DashboardPages.Stats,
    },
    {
      icon: UserIcon,
      label: 'Mes Informations',
      path: DashboardPages.Profile,
    },
  ],
});
